import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-94504de6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, " UI Page ", -1))
const _hoisted_3 = { class: "elements-wrapper" }
const _hoisted_4 = { class: "item app-add-button" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "element-title" }, "AppAddButton", -1))
const _hoisted_6 = { class: "item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "element-title" }, "AppAlert", -1))
const _hoisted_8 = { class: "item app-button" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "element-title" }, "AppButton", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Click Me")
const _hoisted_11 = { class: "item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "element-title" }, "AppCheckbox", -1))
const _hoisted_13 = { class: "item circle-action" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "element-title" }, "AppCircleActionMenu", -1))
const _hoisted_15 = { class: "item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "element-title" }, "AppDatePicker", -1))
const _hoisted_17 = { class: "item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "element-title" }, "AppDropdown", -1))
const _hoisted_19 = { class: "item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "element-title" }, "AppFormItem", -1))
const _hoisted_21 = { class: "item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "element-title" }, "AppInput", -1))
const _hoisted_23 = { class: "item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "element-title" }, "AppLabelInput", -1))
const _hoisted_25 = { class: "item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "element-title" }, "AppLazyImage", -1))
const _hoisted_27 = { class: "item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "element-title" }, "AppLink", -1))
const _hoisted_29 = { class: "item app-loader" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "element-title" }, "AppLoader", -1))
const _hoisted_31 = { class: "item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "element-title" }, "AppMessageInput", -1))
const _hoisted_33 = { class: "item app-progress" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "element-title" }, "AppProgress", -1))
const _hoisted_35 = { class: "item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "element-title" }, "AppSearch", -1))
const _hoisted_37 = { class: "item" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "element-title" }, "AppSelect", -1))
const _hoisted_39 = { class: "item small-loader" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "element-title" }, "AppSmallLoader", -1))
const _hoisted_41 = { class: "item" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "element-title" }, "AppUploadInfo", -1))
const _hoisted_43 = {
  key: 1,
  style: {"position":"fixed","top":"0","left":"0","width":"100%","height":"100%","overflow-y":"scroll"}
}
const _hoisted_44 = { class: "desktop-wrapper" }
const _hoisted_45 = { class: "desktop-item app-add-button" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-element-title" }, "AppAddButton:", -1))
const _hoisted_47 = { class: "desktop-item" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-element-title" }, "AppAlert:", -1))
const _hoisted_49 = { class: "desktop-item app-button" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-element-title" }, "AppButton:", -1))
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Click Me")
const _hoisted_52 = { class: "desktop-item" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-element-title" }, "AppCheckbox:", -1))
const _hoisted_54 = { class: "desktop-item circle-action" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-element-title" }, "AppCircleActionMenu:", -1))
const _hoisted_56 = { class: "desktop-item" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-element-title" }, "AppDatePicker:", -1))
const _hoisted_58 = { class: "desktop-item" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-element-title" }, "AppDropdown:", -1))
const _hoisted_60 = { class: "desktop-item" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-element-title" }, "AppFormItem:", -1))
const _hoisted_62 = { class: "desktop-item" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-element-title" }, "AppInput:", -1))
const _hoisted_64 = { class: "desktop-item" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-element-title" }, "AppLabelInput:", -1))
const _hoisted_66 = { class: "desktop-item" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-element-title" }, "AppLazyImage:", -1))
const _hoisted_68 = { class: "desktop-item" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-element-title" }, "AppLink:", -1))
const _hoisted_70 = { class: "desktop-item app-loader" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-element-title" }, "AppLoader:", -1))
const _hoisted_72 = { class: "desktop-item" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-element-title" }, "AppMessageInput:", -1))
const _hoisted_74 = { class: "desktop-item app-progress" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-element-title" }, "AppProgress:", -1))
const _hoisted_76 = { class: "desktop-item" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-element-title" }, "AppSearch:", -1))
const _hoisted_78 = { class: "desktop-item" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-element-title" }, "AppSelect:", -1))
const _hoisted_80 = { class: "desktop-item small-loader" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-element-title" }, "AppSmallLoader:", -1))
const _hoisted_82 = { class: "desktop-item" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-element-title" }, "AppUploadInfo:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_add_button = _resolveComponent("app-add-button")!
  const _component_app_alert = _resolveComponent("app-alert")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_checkbox = _resolveComponent("app-checkbox")!
  const _component_app_circle_action_menu = _resolveComponent("app-circle-action-menu")!
  const _component_app_date_picker = _resolveComponent("app-date-picker")!
  const _component_app_dropdown = _resolveComponent("app-dropdown")!
  const _component_app_form_item = _resolveComponent("app-form-item")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_label_input = _resolveComponent("app-label-input")!
  const _component_app_lazy_image = _resolveComponent("app-lazy-image")!
  const _component_app_link = _resolveComponent("app-link")!
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_app_message_input = _resolveComponent("app-message-input")!
  const _component_app_progress = _resolveComponent("app-progress")!
  const _component_app_search = _resolveComponent("app-search")!
  const _component_app_select = _resolveComponent("app-select")!
  const _component_app_small_loader = _resolveComponent("app-small-loader")!
  const _component_app_upload_info = _resolveComponent("app-upload-info")!

  return (_ctx.mobileView)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_app_add_button)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_app_alert, { title: _ctx.error }, null, 8, ["title"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_app_button, null, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_app_checkbox, { name: "" })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_app_circle_action_menu)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_app_date_picker, {
              label: "",
              format: "",
              type: "",
              name: ""
            })
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_app_dropdown)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_app_form_item)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode(_component_app_input, {
              label: "",
              name: ""
            })
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createVNode(_component_app_label_input)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createVNode(_component_app_lazy_image, {
              url: "~@/assets/img/logo.svg",
              class: "lazy-image"
            })
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createVNode(_component_app_link)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createVNode(_component_app_loader)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createVNode(_component_app_message_input)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createVNode(_component_app_progress)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createVNode(_component_app_search)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createVNode(_component_app_select, {
              options: "",
              placeholder: "",
              label: "",
              name: ""
            })
          ]),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createVNode(_component_app_small_loader)
          ]),
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _createVNode(_component_app_upload_info, { "upload-info": "" })
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _hoisted_46,
            _createVNode(_component_app_add_button)
          ]),
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _createVNode(_component_app_alert, { title: _ctx.error }, null, 8, ["title"])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _hoisted_50,
            _createVNode(_component_app_button, null, {
              default: _withCtx(() => [
                _hoisted_51
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_52, [
            _hoisted_53,
            _createVNode(_component_app_checkbox, { name: "" })
          ]),
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            _createVNode(_component_app_circle_action_menu)
          ]),
          _createElementVNode("div", _hoisted_56, [
            _hoisted_57,
            _createVNode(_component_app_date_picker, {
              label: "",
              format: "",
              type: "",
              name: ""
            })
          ]),
          _createElementVNode("div", _hoisted_58, [
            _hoisted_59,
            _createVNode(_component_app_dropdown)
          ]),
          _createElementVNode("div", _hoisted_60, [
            _hoisted_61,
            _createVNode(_component_app_form_item)
          ]),
          _createElementVNode("div", _hoisted_62, [
            _hoisted_63,
            _createVNode(_component_app_input, {
              label: "",
              name: ""
            })
          ]),
          _createElementVNode("div", _hoisted_64, [
            _hoisted_65,
            _createVNode(_component_app_label_input)
          ]),
          _createElementVNode("div", _hoisted_66, [
            _hoisted_67,
            _createVNode(_component_app_lazy_image, {
              url: "~@/assets/img/logo.svg",
              class: "lazy-image"
            })
          ]),
          _createElementVNode("div", _hoisted_68, [
            _hoisted_69,
            _createVNode(_component_app_link)
          ]),
          _createElementVNode("div", _hoisted_70, [
            _hoisted_71,
            _createVNode(_component_app_loader)
          ]),
          _createElementVNode("div", _hoisted_72, [
            _hoisted_73,
            _createVNode(_component_app_message_input)
          ]),
          _createElementVNode("div", _hoisted_74, [
            _hoisted_75,
            _createVNode(_component_app_progress)
          ]),
          _createElementVNode("div", _hoisted_76, [
            _hoisted_77,
            _createVNode(_component_app_search)
          ]),
          _createElementVNode("div", _hoisted_78, [
            _hoisted_79,
            _createVNode(_component_app_select, {
              options: "",
              placeholder: "",
              label: "",
              name: ""
            })
          ]),
          _createElementVNode("div", _hoisted_80, [
            _hoisted_81,
            _createVNode(_component_app_small_loader)
          ]),
          _createElementVNode("div", _hoisted_82, [
            _hoisted_83,
            _createVNode(_component_app_upload_info, { "upload-info": "" })
          ])
        ])
      ]))
}